import { render, staticRenderFns } from "./SliceQuote.vue?vue&type=template&id=118c271a&scoped=true&"
import script from "./SliceQuote.vue?vue&type=script&lang=js&"
export * from "./SliceQuote.vue?vue&type=script&lang=js&"
import style0 from "./SliceQuote.vue?vue&type=style&index=0&id=118c271a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118c271a",
  null
  
)

export default component.exports